import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Check, Shield, CreditCard, Percent } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const PricingPage = () => {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-foreground mb-4">{t('simplePricing')}</h1>
            <p className="text-xl text-muted-foreground">{t('noHiddenFees')}</p>
          </div>

          {/* Pricing Card */}
          <div className="bg-card border border-border rounded-2xl p-8 max-w-lg mx-auto mb-12">
            <div className="text-center mb-8">
              <div className="text-5xl font-bold text-foreground mb-2">0%</div>
              <div className="text-lg text-muted-foreground">{t('platformFee')}</div>
            </div>
            <ul className="space-y-4 mb-8">
              <li className="flex items-center gap-3">
                <Check className="w-5 h-5 text-green-500" />
                <span className="text-foreground">{t('freeToStart')}</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="w-5 h-5 text-green-500" />
                <span className="text-foreground">{t('noPlatformFeesOnDonations')}</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="w-5 h-5 text-green-500" />
                <span className="text-foreground">{t('paymentProcessingFee')}</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="w-5 h-5 text-green-500" />
                <span className="text-foreground">{t('instantWithdrawals')}</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="w-5 h-5 text-green-500" />
                <span className="text-foreground">{t('support')} available</span>
              </li>
            </ul>
            <Link to="/create">
              <Button className="w-full bg-gradient-to-r from-emerald-500 to-teal-600">{t('startYourCampaign')}</Button>
            </Link>
          </div>

          {/* Fee Breakdown */}
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <div className="bg-card border border-border rounded-xl p-6 text-center">
              <Percent className="w-8 h-8 text-emerald-500 mx-auto mb-3" />
              <h3 className="font-semibold text-foreground mb-2">{t('platformFee')}</h3>
              <p className="text-3xl font-bold text-foreground mb-2">0%</p>
              <p className="text-sm text-muted-foreground">{t('noPlatformFee')}</p>
            </div>
            <div className="bg-card border border-border rounded-xl p-6 text-center">
              <CreditCard className="w-8 h-8 text-teal-500 mx-auto mb-3" />
              <h3 className="font-semibold text-foreground mb-2">{t('transactionFee')}</h3>
              <p className="text-3xl font-bold text-foreground mb-2">2.9%</p>
              <p className="text-sm text-muted-foreground">+ $0.30</p>
            </div>
            <div className="bg-card border border-border rounded-xl p-6 text-center">
              <Shield className="w-8 h-8 text-emerald-500 mx-auto mb-3" />
              <h3 className="font-semibold text-foreground mb-2">{t('donorProtection')}</h3>
              <p className="text-3xl font-bold text-foreground mb-2">{t('freePlatform')}</p>
              <p className="text-sm text-muted-foreground">{t('donorGuarantee')}</p>
            </div>
          </div>
          
          {/* Billing Contact */}
          <div className="text-center text-muted-foreground">
            <p>Questions about billing or payments? Contact us at{' '}
              <a href="mailto:billing@fundthehope.com" className="text-emerald-500 hover:underline">billing@fundthehope.com</a>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PricingPage;
